import { html, css, LitElement } from 'lit';
import './seb-contact-form.js';

export class SebDemo extends LitElement {
  static shadowRootOptions = {
    ...LitElement.shadowRootOptions,
    delegatesFocus: true,
  };

  static styles = css`
    :host {
      display: block;
      color: var(--seb-text-color, #111927);
    }
  `;

  render() {
    return html`
      <seb-contact-form
        style="--seb-text-color: black; --seb-primary-color: #6366F1"
        .btnSubmitTextColor=${'white'}
        .btnSubmitText=${'Enviar'}
        .loadingText=${'Carregando...'}
        .noResultsText=${'Nenhum resultado encontrado'}
        .fieldsLabels=${{
          name: 'Nome',
          email: 'E-mail',
          phone: 'Telefone',
          zip: 'CEP/ZIP',
          country: 'País',
          state: 'Estado',
          city: 'Cidade',
        }}
      />
    `;
  }
}
